
export default function WhyChooseUsSection() {
  const reasons = [
    {
      icon: 'ri-map-pin-line',
      title: 'Mobile Convenience',
      description: 'We come to your home, office, or any location in Melbourne. No need to waste time driving to a car wash.'
    },
    {
      icon: 'ri-time-line',
      title: 'Flexible Scheduling',
      description: 'Book appointments that fit your busy schedule, including weekends and after-hours service.'
    },
    {
      icon: 'ri-award-line',
      title: 'Premium Products',
      description: 'We use only the highest quality products and professional-grade equipment for superior results.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Expert Technicians',
      description: 'Our experienced team delivers consistent, showroom-quality results every time.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Competitive Pricing',
      description: 'Fair, transparent pricing with no hidden fees. Quality service at affordable rates.'
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-white mb-4">
            <strong>Why Melbourne Chooses Starlight Motors</strong>
          </h3>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Trusted by hundreds of Melbourne car owners for our professional mobile detailing services, 
            premium quality, and unmatched convenience.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
              <div className="w-20 h-20 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-500 transition-colors duration-300">
                <i className={`${reason.icon} text-3xl text-teal-400 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-4">
                <strong>{reason.title}</strong>
              </h4>
              <p className="text-gray-400 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-gray-800 rounded-2xl p-8 text-center border border-gray-700">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <div className="text-3xl font-bold text-teal-400 mb-2">5★</div>
              <div className="text-gray-300 font-semibold">Average Rating</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-teal-400 mb-2">100%</div>
              <div className="text-gray-300 font-semibold">Satisfaction Guarantee</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
